import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureToggle } from '@cnx-saas/feature-toggle';

import { BeforeInstallPromptEvent } from '../../before-install-prompt-event';

import {
  PWAInstallButton,
  PWAInstallLabel,
  PWAInstallIcon,
} from './pwa-install-button.style';

function PwaInstallButton({
  pwaInstallEvent,
  isSidebarOpen,
}: {
  pwaInstallEvent: BeforeInstallPromptEvent | null;
  isSidebarOpen: boolean;
}): JSX.Element | null {
  const { t } = useTranslation();

  const isAllowedToInstallPWA = useFeatureToggle('isAllowedToInstallPWA');

  if (!isAllowedToInstallPWA || !pwaInstallEvent) {
    return null;
  }

  const handleInstallButtonClick = () => {
    pwaInstallEvent.prompt();
  };

  return (
    <PWAInstallButton
      onClick={handleInstallButtonClick}
      color={isSidebarOpen ? 'secondary' : 'primary'}
      size="small"
    >
      <PWAInstallIcon isSidebarOpen={isSidebarOpen} />
      {isSidebarOpen && (
        <PWAInstallLabel>{t('pwa.installButton.label')}</PWAInstallLabel>
      )}
    </PWAInstallButton>
  );
}

export { PwaInstallButton };
